import { useMemo, useState } from 'react'
import * as ServicoNfseHttp from '../../../../services/api/https/registration/servico-nfse.http'
import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING: 'Carregando',
}

const buildInitialState = () => ({
  servicos: [],
  modal: { show: false, data: null },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  globalFilter: '',
})

export default function useServicoNfse() {
  const [state, setState] = useState(buildInitialState)

  const localDispatch = useMemo(() => {
    const semTp = () =>
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: 'Selecione um Operador Logístico',
      }))

    return {
      onInit(selectedTp) {
        if (!selectedTp) return semTp()
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.LOADING }))
      },

      loadServicos(selectedTp) {
        ServicoNfseHttp.getServicosNfse(selectedTp)
          .then(servicos =>
            setState(prevState => ({ ...prevState, servicos, loadingMessage: LOAD_MESSAGE.NONE })),
          )
          .catch(error =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: errorHandler(error),
            })),
          )
      },

      resetErrorMessage() {
        setState(prevState => ({ ...prevState, errorMessage: null }))
      },

      onBtnNovo(selectedTp) {
        if (!selectedTp) return semTp()
        setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
      },

      // Marcar um serviço como padrão do frete municipal desmarca os outros (a API faz o mesmo)
      onModalSave(servico) {
        setState(prevState => {
          const existe = prevState.servicos.some(item => item.id === servico.id)
          const atualizados = existe
            ? prevState.servicos.map(item => (item.id === servico.id ? servico : item))
            : [servico, ...prevState.servicos]
          return {
            ...prevState,
            servicos: servico.padrao_frete_municipal
              ? atualizados.map(item =>
                  item.id === servico.id ? item : { ...item, padrao_frete_municipal: false },
                )
              : atualizados,
            modal: { show: false, data: null },
          }
        })
      },

      onDataTableItemClicked(servico) {
        setState(prevState => ({ ...prevState, modal: { show: true, data: { ...servico } } }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
